import { createSelector } from "@reduxjs/toolkit";

const EMPTY_LIKE_STATUS = Object.freeze({ liked: false, count: 0 });

export const selectLikesState = (state) => state.likes || {};

export const selectLikesLoading = (state) => selectLikesState(state).loading;

export const selectLikesError = (state) => selectLikesState(state).error;

const selectLikesStatus = (state) => selectLikesState(state).status || {};

export const makeSelectLikeStatusForPost = () =>
  createSelector([selectLikesStatus, (_, postId) => postId], (status, postId) => {
    const pid = postId == null ? "" : String(postId).trim();
    return (pid && status[pid]) ? status[pid] : EMPTY_LIKE_STATUS;
  });
